/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: None = 0, OutsideServiceArea = 1, NoAvailability = 2, RouteConstraints = 3, NoAssignedUsers = 4, FormDisabled = 5, CustomerNotReady = 6
 */
export enum Routemize_Constants_SlotRejectionReason {
    NONE = 'None',
    OUTSIDE_SERVICE_AREA = 'OutsideServiceArea',
    NO_AVAILABILITY = 'NoAvailability',
    ROUTE_CONSTRAINTS = 'RouteConstraints',
    NO_ASSIGNED_USERS = 'NoAssignedUsers',
    FORM_DISABLED = 'FormDisabled',
    CUSTOMER_NOT_READY = 'CustomerNotReady',
}
